export default __webpack_public_path__ + "static/polygon1-8720c2aae9b2f6a531ec484a1b32ebe2.png";